// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__1ycis","upload":"Small_upload__2gORW","imageWrap":"Small_imageWrap__ZtCaJ","removeBtn":"Small_removeBtn__3_mPC"};